import { MenuItem, styled, TextField } from "@mui/material";
import * as React from "react";
import { InfoLabel } from "./info_label";

export default function HelpedSelect({
  options,
  optionKey,
  selected,
  onChange,
  label,
  info,
  valueKey = optionKey,
  fullWidth = true,
  tooltipPlacement = "top",
  iconSize = "medium",
  ...props
}) {
  const StyledTextField = styled(TextField)({
    "& .MuiFormLabel-root": {
      display: "flex",
      alignItems: "center",
      "& .myIcon": {
        paddingLeft: "8px",
        order: 999,
      },
    },
    paddingTop: 0,
  });

  return (
    <StyledTextField
      select
      label={
        info ? <InfoLabel label={label} info={info} tooltipPlacement={tooltipPlacement} iconSize={iconSize} /> : label
      }
      disabled={props.disabled}
      fullWidth={fullWidth}
      sx={{ ...props.sx }}
      value={selected}
      onChange={onChange}
      {...props}
    >
      {options &&
        Object.values(options).map((obj, idx) => {
          return (
            <MenuItem key={idx} value={valueKey ? obj[valueKey] : obj}>
              {optionKey ? obj[optionKey] : obj}
            </MenuItem>
          );
        })}
    </StyledTextField>
  );
}
